import * as React from 'react'
import { useEntity } from '../helpers/selectors'
import { cf2imgix } from '../helpers/imgix-image'
import { Icon } from '../../atoms'
import MultiStepForm from '../form'

const Form = ({ form }: { form: any }) => {
  const formEntity = useEntity(form)

  return (
    <div className='PpcBenefit__form'>
      {formEntity.schema?.label && (
        <div className='PpcBenefit__form__label'>{formEntity.schema.label}</div>
      )}
      <MultiStepForm {...formEntity} />
    </div>
  )
}

const BenefitTile = ({ tile, index }: { tile: any; index: number }) => {
  const tileEntity = useEntity(tile)
  const tileImage = useEntity(tileEntity.image)

  return (
    <div className='PpcBenefit__column' key={index}>
      {tileEntity.image && (
        <img
          className='PpcBenefit__column__image'
          src={cf2imgix(tileImage.file.url)}
          alt={`benefit tile ${index}`}
        />
      )}
      {tileEntity.icon && <Icon glyph={tileEntity.icon} size={32} desktopSize={48} />}
      <div className='PpcBenefit__column__text'>{tileEntity.text}</div>
      {tileEntity.description && (
        <div className='PpcBenefit__column__desc'>{tileEntity.description}</div>
      )}
    </div>
  )
}

const BenefitsModule = ({
  title,
  subTitle,
  collection,
  form,
}: {
  title: string
  subTitle: string
  collection: any
  form: any
}) => {
  return (
    <div className='PpcBenefit'>
      <h3>{title}</h3>
      {subTitle && <h4>{subTitle}</h4>}
      {collection && (
        <div className='PpcBenefit__columns'>
          {collection.map((tile: any, index: number) => (
            <BenefitTile tile={tile} index={index} key={index} />
          ))}
        </div>
      )}
      {form && <Form form={form} />}
    </div>
  )
}

export default BenefitsModule
